import { Avatar, Box, Stack, Typography } from '@mui/material';
import React from 'react';
import './About.css'
import My from '../About/about1.png';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <Stack
    id='about'
    
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      sx={{
        pt: 20,
        justifyContent: 'space-evenly',
        px: 2,
        pl: 4,
        pr: 4,
        pb:8, 
        '@media (min-width:100px) and (max-width:800px)': {
          display: 'grid',
          justifyContent: 'center',
          alignItems: 'center',
          gridTemplateColumns: '1fr',
        },
      }}
    >
      <Box
        sx={{ 
          color: 'white',
          backgroundColor: 'lightseagreen',
          borderRadius: '16px',
          padding: 2,
          boxShadow: 2,
          flex: 1,
          minWidth: '250px', 
          transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          '&:hover': {
            minWidth: '300px',
            transform: 'scale(1.06)', 
          },
          '@media (min-width:100px) and (max-width:800px)': {
            borderRadius: '12px',
            padding: 2, 
            '&:hover': {
              minWidth: '100px',
              flex: 1,
            },
          },
        }} 
      >
        <Typography variant="h5" style={{color:'black'}} className="no-select" gutterBottom>
          About Me
        </Typography>
        <Typography variant="body1" className="no-select">
          I am a final-year Computer Science undergraduate with a passion for{' '}
          <span style={{ color: 'yellow' }}>Frontend Development</span> and also learned about{' '}
          <span style={{ color: 'yellow' }}>DataBase Management, Operating Systems</span>. Throughout my academic journey, I've actively participated in{' '}
          <span style={{ color: 'yellow' }}>Hackathons</span>, which have honed my problem-solving skills and deepened my understanding of real-world applications. Additionally, I written a blog on Joins in Medium  <span style={{color: 'black',fontStyle :'italic'}}>'Title : The ABCs of MySQL Joins: A Starter’s Guide'</span>.
          <br />
          <br />
          I believe in continuous learning and have taken part in several webinars to stay updated with the latest trends and innovations in technology. I am excited to leverage my skills and experiences to contribute to{' '}
          <span style={{ color: 'yellow' }}>impactful projects</span> as I embark on my professional journey.
        </Typography>
      </Box>
      <motion.div
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: -100 }}
        transition={{ duration: 1.5 }}
      >
      <Avatar src={My} alt='Sriram'
      sx={{
        height:'300px',
        width:'280px',
        padding:'2rem',
        borderRadius:'70%',
        '&:hover' :{
          height:'400px',
          width:'360px',
          borderRadius:'100%',
          backgroundSize:'cover',
          backgroundPosition:'center',
          transform:'scale(1.1)'
        },
        '@media (min-width:100px) and (max-width:600px)':{
          
        }
      }}></Avatar>
      </motion.div>
      <Box
        sx={{
          color: 'white',
          backgroundColor: 'lightseagreen',
          borderRadius: '16px',
          padding: 2, 
          boxShadow: 2,
          flex: 1,
          minWidth: '250px',
          transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          '&:hover': {
            minWidth: '200px',
            transform: 'scale(1.08)', 
          },
          '@media (min-width:100px) and (max-width:800px)': {
            borderRadius: '12px',
            padding: 2, 
            '&:hover': {
              minWidth: '100px',
              flex: 1,
            }
          }  
        }}
      >
        <Typography variant="h5" style={{color:'black'}} className="no-select" gutterBottom>
          Education
        </Typography>
        <Typography variant="body1" className="no-select">
        {'1.'} Sri Chaitanya Techno School [ X ]
          <br />
          <ul>
           <li style={{color:'yellow',fontSize:'16px'}}>APR-2019</li>
           <li >CGPA : 10/10 </li>
           </ul>
        </Typography>
        <Typography variant="body1" className="no-select">
        {'2.'} Sasi Junior College[ XII ]
          <br />
          <ul>
           <li style={{color:'yellow',fontSize:'16px'}}>MAR-2021</li>
           <li >Marks : 958/1000 </li>
           </ul>
        </Typography>
        <Typography variant="body1" className="no-select">
        {'3.'} KL University[ BTECH ]
          <br />
          <ul>
           <li style={{color:'yellow',fontSize:'16px'}}>AUG-2021 {'<->'} MAY-2025 </li>
           <li >CGPA : 9.58/10 </li>
           </ul>
        </Typography>
      </Box>
    </Stack>
  );
};

export default About;
